import React, { useEffect } from "react";
import { Form, GridRow } from "semantic-ui-react";

// Hooks and Helpers
import useEnforcementForm from "@common/components/hooks/useEnforcementForm";
import { getCurrentDateTime } from "@common/components/helpers/datetime";

// Components
import StandardHiddenInputs from "@common/components/shared/forms/StandardHiddenInputs";
import TextareaComponent from "@common/components/shared/forms/TextareaComponent";
import SelectComponent from "@common/components/shared/forms/SelectComponent";
import ToggleComponent from "@common/components/shared/forms/ToggleComponent";
import DateAndTimeGroup from "@common/components/shared/forms/DateAndTimeGroup";
import OfficerForm from "@common/components/shared/forms/OfficerForm";
import FormButtonsComponent from "@common/components/shared/forms/FormButtonsComponent";
import { setComplianceFormDateTime } from "../../helpers/datetime";
import useLogin from "../../hooks/useLogin";

const EnforcementForm = () => {
  const {
    officerTypeId,
    loadingTypes,
    isGamblingRelated,
    options,
    onSubmit,
    handleNewOfficer,
    handleRemoveOfficer,
    resetForm,
    methods,
  } = useEnforcementForm();

  const {
    control,
    register,
    setValue,
    handleSubmit,
    formState: { isValid, errors },
  } = methods;

  const [{ isDesktop }] = useLogin();

  useEffect(() => {
    if (!isDesktop) {
      setComplianceFormDateTime(setValue);
    }
  }, []);

  return (
    <Form className="form-padding" onSubmit={handleSubmit(onSubmit)}>
      <StandardHiddenInputs />
      <DateAndTimeGroup
        control={control}
        dateFormat="YYYY-MM-DD"
        errorsDate={errors.date}
        errorsTime={errors.time}
        maxDate={getCurrentDateTime()}
      />
      <ToggleComponent
        control={control}
        name="isGamblingRelated"
        label="Gambling related?"
        error={errors.isGamblingRelated}
      />
      {isGamblingRelated !== null && (
        <>
          <SelectComponent
            name="officerTypeId"
            label="Type"
            placeholder="Select type of visitor log"
            control={control}
            error={errors.officerTypeId}
            options={options}
            loading={loadingTypes}
          />
          <GridRow>
            <b>VISIT DETAILS</b>
          </GridRow>
          <TextareaComponent
            name="visitDetails"
            label="Nature of visit"
            placeholder="Enter details of the nature of the visit"
            register={register}
            error={errors.visitDetails}
          />
          {officerTypeId && (
            <OfficerForm
              handleNewOfficer={handleNewOfficer}
              handleRemoveOfficer={handleRemoveOfficer}
            />
          )}
          <TextareaComponent
            name="comments"
            label="Comments"
            placeholder="Enter comments..."
            register={register}
            error={errors.comments}
          />
        </>
      )}
      <FormButtonsComponent
        isValid={isValid}
        centered={true}
        resetForm={() => resetForm(false)}
      />
    </Form>
  );
};

export default EnforcementForm;
